// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"18b2d075","458":"abdbc9f8","576":"830b662b","829":"5a43b13a"}[chunkId] + ".chunk.css";
};